import { signal } from "@angular/core";

export const chartThemeToken = signal<"dark" | "light">("light");
